<script setup>
import { ref, computed, watch } from 'vue';
import {
    VTextField,
    VMenu,
    VCard,
    VCardActions,
    VSpacer,
    VBtn,
    VTimePicker
} from 'vuetify/components';
import TooltipInputError from '@/components/widgets/TooltipInputError.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
    modelValue: String,
    label: String,
    errorMessages: [String, Array],
    disabled: Boolean,
    format: {
        type: String,
        default: '24hr'
    },
    variant: String,
    density: String,
    hideDetails: Boolean,
    inputClass: String
});

const emit = defineEmits(['update:modelValue']);

const menu = ref(false);
const internalValue = ref(props.modelValue);

watch(
    () => props.modelValue,
    (val) => {
        internalValue.value = val;
    }
);

const displayValue = computed(() => {
    return internalValue.value || '';
});

function onTimeSelected(val) {
    emit('update:modelValue', val);
}

function closeMenuOnMinute(val) {
    emit('update:modelValue', val);
}
</script>

<template>
    <div style="display: flex; align-items: center">
        <TooltipInputError
            v-if="errorMessages"
            :error="errorMessages"
            style="margin-left: 8px"
        />
        <VMenu v-model="menu" :close-on-content-click="false" offset-y>
            <template #activator="{ props: activatorProps }">
                <VTextField
                    v-bind="activatorProps"
                    :label="label"
                    :model-value="displayValue"
                    readonly
                    :error-messages="errorMessages"
                    :disabled="disabled"
                    :variant="variant"
                    :density="density"
                    :hide-details="hideDetails"
                    :class="inputClass"
                    color="primary"
                />
            </template>
            <VCard>
                <VTimePicker
                    v-model="internalValue"
                    :format="format"
                    @update:modelValue="onTimeSelected"
                    @click:minute="closeMenuOnMinute(internalValue)"
                />
                <VCardActions>
                    <VSpacer />
                    <VBtn color="primary" text @click="menu = false">{{
                        t('Close')
                    }}</VBtn>
                </VCardActions>
            </VCard>
        </VMenu>
    </div>
</template>
